import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { NotificationService } from 'src/app/service/notification.service';
import { environment } from 'src/environments/environment';
declare var bootstrap: any;

// interface TimeSlot {
//   startTime: string;
//   endTime: string;
//   disabled?: boolean;
//   booked_data:string;
// }

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  applicant_token:any;
  selectedDate: Date = new Date();
  availableSlots: any[] = [];
  selectedSlot: any | null = null;
  public modal: any;

  constructor(
    public api: ApiService,
    private notification: NotificationService
  ) {
    this.applicant_token = this.api.decryptData(localStorage.getItem('applicant-token-detail'));
  }
  user_id:any;
  user_role:any;
  ngOnInit(): void {
    this.api.AppointmentGetToken()
    // Initialize with to's date
    this.selectedDate = new Date();
    this.selectedDate.setDate(this.selectedDate.getDate());
    // this.getSlots({ value: this.selectedDate });
    this.getUserRole();
    
    // Initialize Bootstrap modal
    this.modal = new bootstrap.Modal(document.getElementById('appointmentModal'));
  }

  getUserCheck(event:any){
    console.log("user_id",event);
    this.user_id=event;
    this.getSlots({ value: this.selectedDate });
  }

  getSlots(event:any) {
    // Adjust the selected date to account for timezone differences
    let adjustedDate = new Date(event);
    if(isNaN(adjustedDate.getTime())){
      let currentDate = new Date();
      adjustedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());  
    }
    adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset());
    console.log("getSlots",adjustedDate);
    // Clear existing slots
    this.availableSlots = [];
    this.selectedSlot = null;
    let date = adjustedDate.toISOString().split('T')[0];
    let data = {
       'application':[3],
       'from_date':date,
       'doc_user_id':this.user_id
       }
    this.api.AppointmentPostAPI('configuration/slot-listing', data).subscribe((res:any)=>{
      console.log("AppointmentGetSlots",res);
      let slots = res.data;
      
      // Initialize availableSlots array
      this.availableSlots = [];
      
      // Check if we have valid slot data
      if (slots && Array.isArray(slots)) {
        slots.forEach((slot: any) => {
          try {
            let availableSlot = parseInt(slot.available) || 1;

            // Combine date and time for proper parsing
            const today = date; // Current date from the request
            const startTimeStr = `${today}T${slot.start_time}`;
            const endTimeStr = `${today}T${slot.end_time}`;

            let startTime = new Date(startTimeStr);
            let endTime = new Date(endTimeStr);

            if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
              console.error("Invalid date format in slot:", slot);
              return; // Skip this slot
            }

            // Calculate time in milliseconds for each slot
            let slotDuration = (endTime.getTime() - startTime.getTime()) / availableSlot;

            for (let i = 0; i < availableSlot; i++) {
              let slotStartTime = new Date(startTime.getTime() + i * slotDuration);
              let slotEndTime = new Date(slotStartTime.getTime() + slotDuration);

              // Check lunch time slots
              let isLunchSlot = false;
              if (slot.lunch_start_time && slot.lunch_end_time) {
                const lunchStartTime = new Date(`${today}T${slot.lunch_start_time}`);
                const lunchEndTime = new Date(`${today}T${slot.lunch_end_time}`);
                
                if (
                  (slotStartTime >= lunchStartTime && slotStartTime < lunchEndTime) ||
                  (slotEndTime > lunchStartTime && slotEndTime <= lunchEndTime) ||
                  (slotStartTime <= lunchStartTime && slotEndTime >= lunchEndTime)
                ) {
                  isLunchSlot = true;
                }
              }

              // Format times as strings to match TimeSlot interface
              let formattedSlotStartTime = slotStartTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
              let formattedSlotEndTime = slotEndTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
              let formattedSlotTimeRange = `${formattedSlotStartTime} to ${formattedSlotEndTime}`;

              const currentTime = new Date();
              const isSlotAlreadyExists = this.availableSlots.some(existingSlot => 
                existingSlot.startTime === formattedSlotStartTime && existingSlot.endTime === formattedSlotEndTime
              );

              
              // Skip duplicates
              if (!isSlotAlreadyExists) {
                // Check if slot is in the past
                const isDisabled = slotStartTime <= currentTime;
                
                // Add slot to available slots
                this.availableSlots.push({
                  booked_data: date,
                  startTime: formattedSlotStartTime,
                  endTime: formattedSlotEndTime,
                  disabled: isDisabled || isLunchSlot,
                  booked: false,
                  isLunchSlot: isLunchSlot
                });
              }
            }
          } catch (error) {
            console.error("Error processing slot:", error, slot);
          }
        });

        // Mark booked slots as disabled after all slots are created
        const appointmentDetails = res.data?.[0]?.appointment_details;
        if (Array.isArray(appointmentDetails) && appointmentDetails.length > 0) {
          console.log("Checking booked slots:", appointmentDetails);

          // Update booked status for slots in availableSlots
          this.availableSlots.forEach((slot: any) => {
            // Format the slot time range to match the API format exactly
            const slotTimeRange = `${slot.startTime} to ${slot.endTime}`;
            console.log("slotTimeRange", slotTimeRange);
            // Check if this slot is booked
            const isBooked = appointmentDetails.some((booked: any) => {
              return slotTimeRange === booked.booked_time;
            });
            if (isBooked) {
              console.log("slot is booked", slot);
              slot.booked = true;
              slot.disabled = true;
            } else {
              console.log("slot is not booked", slot);
              slot.booked = false;
              if(slot.disabled){
                slot.disabled = true;
              }else{
                slot.disabled = false;
              }
            }
          });
        }
      }
      console.log("Final availableSlots:", this.availableSlots);
    }, error => {
      console.error("Error fetching slots:", error);
    });
  }

  selectSlot(slot: any) {
        this.selectedSlot = slot
      }

    DoctorRole:any;
    Doctor:any;
  openConfirmModal() {
    if( this.selectedSlot && this.user_id && this.user_role){
      this.DoctorRole = this.UserRole.find((item:any)=>item.id == this.user_role);
      this.Doctor = this.userLists.find((item:any)=>item.id == this.user_id);
      this.modal.show();
    }else{
      this.notification.displayMessage("Please select a slot and user");
    }
  }
  

  isLoading:boolean=false;
  confirmAppointment() {
    this.isLoading=true;
    let data = [
      {
        "action_date":this.selectedDate.toISOString().split('T')[0],
        "applicant_id": this.applicant_token.user_id,
        "booked_time": this.selectedSlot?.startTime + " to " + this.selectedSlot?.endTime,
        "booking_by": this.applicant_token.user_id,
        "booking_from": 3,
        "booking_status": 1,
        "date_booked": new Date().toISOString().split('T')[0],
        "department": "gp",
        "doc_user_id": this.user_id,
        "doc_user_name": this.Doctor?.first_name + " " + this.Doctor?.last_name,
        "doc_role_id": this.user_role,
        "doc_role_name": this.DoctorRole?.name,
        "description": "MH - Patient History Taking Packagelity",
        "patient_name": this.applicant_token?.first_name + " " + this.applicant_token?.last_name,
        "patient_email": this.applicant_token?.user_email,
        "patient_phone": this.applicant_token?.mobile,
        "referral_id": Math.floor(Math.random() * 10000000000000000),
        "service": "MH - Patient History Taking Package",
        "service_code": "MHPHTP",
        "visa_number": this.applicant_token.patient_number
      }
    ]
    console.log('Appointment Details:', data);
    if(data.length > 0){
      this.api.AppointmentPostAPI('transaction/book_appointment/save', data).subscribe((res:any)=>{
        console.log("AppointmentCreate",res);
        if(res.status==environment.SUCCESS_CODE){
          this.notification.success(res.message);
          this.modal.hide();
          this.selectedSlot = null;
          this.isLoading=false;
          this.getSlots({ value: this.selectedDate });
        }else{
          this.notification.displayMessage(res.message);
        }
      })
    }
  
  }

  UserRole:any
  getUserRole(){
    let searchString='?status=1&'
    searchString+='&process_id=5';
    this.api.getAPI(environment.API_URL+"access/access_user_roles"+searchString).subscribe((res)=>{
      this.UserRole = res.data;
      console.log("UserRole",this.UserRole)
    })
  }
  userLists:any
  getUser(user_role:any){ 
    this.user_role=user_role;
    this.api.getAPI(environment.API_URL+"access/users?user_role__id_in="+user_role+'&status=1').subscribe((res)=>{
      this.userLists=res.data;  
      if(this.userLists.length > 0 && this.userLists.length == 1){
        this.user_id=this.userLists[0].id;
        this.getSlots({ value: this.selectedDate });
      }
    })
  }

  closeModal() {
    this.modal.hide();
  }
}
